import { findParent } from '../../tools/helpers';
import getEventHandlerResize from '../ResizeHandler';

class ImageLoaderBase {
  constructor(options = {}) {
    this.LOAD_INIT = 'bfv-image--load-init';
    this.LOADING = 'bfv-image--loading';
    this.LOAD_FINISHED = 'bfv-image--load-finished';
    this.LOAD_ERROR = 'bfv-image--load-error';

    this.stateLoading = this.LOAD_INIT;
    this.stateLoadedOnce = false;
    this.$root = options.element;
    this.parentElementClass = 'balloon-wrapper';
    this.parentBalloonElement = findParent(this.$root, this.parentElementClass);
    this.imageElement = null;

    this.currentBreakpointKey = null;
    this.targetAssetMap = {
      XSMALL: 'small',
      MEDIUM: 'medium',
      LARGE: 'large',
    };
    this.targetAsset = this.getTargetImageAsset();

    // attributes
    this.attrSource = 'data-img-src';
    this.attrSourceMedium = 'data-img-src-medium';
    this.attrSourceLarge = 'data-img-src-large';
    this.attrAlt = 'data-img-alt';
    this.attrTitle = 'data-img-title';
    this.attrDisableAutoLoad = 'data-disable-auto-load';
    this.disableAutoLoad = this.$root.getAttribute(this.attrDisableAutoLoad) !== null;
  }

  init() {}

  bindEvents() {}

  /**
   *
   * @returns {boolean|string}
   */
  getTargetImageAsset() {
    this.currentBreakpointKey = getEventHandlerResize().getCurrentViewport();

    if (this.targetAssetMap.hasOwnProperty(this.currentBreakpointKey)) {
      return this.targetAssetMap[this.currentBreakpointKey];
    }
    return false;
  }

  prepareDOM() {

    // create image element and append to DOM
    if (!this.imageElement) {
      this.imageElement = new Image();
      this.imageElement.setAttribute('draggable', false);
      this.imageElement.addEventListener('load', (event) => this.handleEventLoad(event));
      this.imageElement.addEventListener('error', (event) => this.handleEventLoad(event));
      this.$root.appendChild(this.imageElement);

      this.stateLoading = this.LOAD_INIT;
      this.$root.classList.add(this.LOAD_INIT);
    }
  }

  /**
   * LOAD FUNCTIONS
   */

  loadImageSourceOnce(imageSource) {
    /**
     * make sure that image gets (successfully) loaded just one time
     */
    if (!this.stateLoadedOnce) {
      this.replaceImageSource(imageSource);
    }
  }

  replaceImageSource(imageSource) {
    /**
     * actual trigger to load specified image source
     * and fire load and error events when image was loaded
     */
    this.imageElement.src = imageSource;

    // hide title and alt during image load
    this.imageElement.setAttribute('alt', this.$root.getAttribute(this.attrAlt));
    this.imageElement.setAttribute('title', this.$root.getAttribute(this.attrTitle));

    this.stateLoading = this.LOADING;
    this.$root.classList.add(this.LOADING);
    this.$root.classList.remove(this.LOAD_INIT);
    // this.$root.classList.remove(this.LOAD_FINISHED);
  }

  /**
   * EVENT HANDLING
   */

  handleEventLoad(event) {
    // display title and alt after image load is finished
    this.imageElement.setAttribute('alt', this.$root.getAttribute(this.attrAlt));
    this.imageElement.setAttribute('title', this.$root.getAttribute(this.attrTitle));

    switch (event.type) {
      case 'error':
        this.stateLoading = this.LOAD_ERROR;
        this.$root.classList.remove(this.LOADING);
        this.$root.classList.remove(this.LOAD_FINISHED);
        this.$root.classList.add(this.LOAD_ERROR);
        this.parentBalloonElement.classList.remove(`${this.parentElementClass}--loaded`);
        break;

      case 'load':
        this.stateLoadedOnce = true;
        this.stateLoading = this.LOAD_FINISHED;
        this.parentBalloonElement.classList.add(`${this.parentElementClass}--loaded`);
        this.$root.classList.remove(this.LOADING);
        this.$root.classList.remove(this.LOAD_ERROR);
        this.$root.classList.add(this.LOAD_FINISHED);
        this.$root.removeAttribute('style');

        window.setTimeout(() => {
          // calculation in stageImage in IE did not work without 0-timeout
          this.callbackImageLoaded();
        }, 0);
        break;

      default:
        break;
    }
  }

  callbackImageLoaded() {
    // OVERRIDE IN SUB-CLASS
  }

  getAttributeSource(dataSource = this.attrSource) {
    return this.$root.getAttribute(dataSource);
  }

  getStatusLoadedOnce() {
    return this.stateLoadedOnce;
  }

}

export default ImageLoaderBase;
